// extracted by mini-css-extract-plugin
export default {"user":"Profile_user__A9ATM","link":"Profile_link__0Ji0W"};